window.Reverb = window.Reverb || {};
Reverb.LegacyRefundRequests = (function () {
  function init() {
    $(document).on('click', '[name=\'order_refund_request[refund_type]\']', function () {
      $('[data-refund-type]').hide();
      $(`[data-refund-type='${$(this).val()}']`).fadeIn();
    });
  }

  return {
    init,
  };
}());

$(document).ready(() => {
  Reverb.LegacyRefundRequests.init();
});
